import { PanelLeft, ChevronRight } from 'lucide-react';
import type { BreadcrumbSegment } from './types';

interface MiniTopbarProps {
  segments: BreadcrumbSegment[];
}

export function MiniTopbar({ segments }: MiniTopbarProps) {
  return (
    <div className="border-b border-border-subtle bg-surface-panel shrink-0 relative">
      <div className="flex items-center px-2 py-1.5 relative">
        <div className="flex items-center shrink-0 z-10">
          <PanelLeft size={10} className="text-text-tertiary shrink-0" />
        </div>

        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[70%] min-w-0 pointer-events-none">
          <div className="flex items-center justify-center gap-1 text-[7px] font-[var(--fw-medium)] text-text-tertiary min-w-0">
            {segments.map((seg, i) => {
              const Icon = seg.icon;
              const isLast = i === segments.length - 1;
              return (
                <span key={i} className="contents">
                  {i > 0 && <ChevronRight size={7} className="text-text-quaternary shrink-0" />}
                  {Icon && <Icon size={7} className="text-text-quaternary shrink-0" />}
                  <span className={isLast ? 'truncate text-text-secondary' : 'shrink-0'}>{seg.label}</span>
                </span>
              );
            })}
          </div>
        </div>

        <div className="ml-auto flex items-center shrink-0 z-10">
          <div className="size-4 rounded-full bg-surface-frost-08 flex items-center justify-center">
            <span className="text-[6px] font-[var(--fw-medium)] text-text-tertiary">SK</span>
          </div>
        </div>
      </div>
    </div>
  );
}
